//usePermission.ts
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const usePermission = (module: string, action: 'view' | 'create' | 'update' | 'delete') => {
  const permissions = useSelector((state: RootState) => state.roleAndPermission.permissions);
  return permissions?.[module]?.[action] ?? false;
};